import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Container,
  Menu,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import { flashSuccessMessage, flashErrorMessage } from '../../actions/flash';
import NavBar from '../../components/NavBar';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';
import Form from './Form';

class EditLogo extends Component {
  static propTypes = {
    token: PropTypes.string,
    id: PropTypes.string,
    loading: PropTypes.bool,
    data: PropTypes.shape({
      name: PropTypes.string,
    }),
    onCheck: PropTypes.func,
    t: PropTypes.func,
  }
  static contextTypes = {
    store: PropTypes.object,
  }
  constructor(props) {
    super(props);
    this.state = {
      hasChanges: false,
    };
  }
  async submit(validations, file) {
    const { store } = this.context;
    const errors = validations.filter(v => !v.isValid);
    if (errors.length > 0) {
      store.dispatch(flashErrorMessage({ header: 'Please fix form errors', list: errors.map(l => l.message) }));
      return;
    }
    try {
      await this.form.getWrappedInstance().submit(`/logos/${this.props.id}/`, {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
        body: JSON.stringify(file),
      });
    } catch (err) {
      if (err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      store.dispatch(flashErrorMessage(err));
      return;
    }
    this.setState({ hasChanges: false }, () => {
      this.handleOnCheck(false);
    });
    store.dispatch(flashSuccessMessage({ header: 'Update Success', message: 'Logo successfully updated' }));
  }
  handleSubmit = (event) => {
    this.form.getWrappedInstance().handleSubmit(event);
  }
  handleOnChange = (hasChanges) => {
    if (hasChanges !== this.state.hasChanges) {
      this.setState({ hasChanges }, () => {
        this.handleOnCheck(hasChanges);
      });
    }
  }
  handleOnCheck = (hasChanges = false) => {
    if (this.props.onCheck) {
      this.props.onCheck(hasChanges);
    }
  }
  render() {
    const { t } = this.props;
    return (
      <Container>
        <NavBar
          header={t('Edit logo')}
          rightNav={
            <Menu.Item fitted>
              <Button
                positive
                content={t('Save', { ns: TRANSLATION_FILES.translation })}
                onClick={this.handleSubmit}
                disabled={!this.state.hasChanges}
              />
            </Menu.Item>
          }
        />
        <Form
          ref={(ref) => { this.form = ref; }}
          onSubmit={(validations, unit) => {
            this.submit(validations, unit);
          }}
          onChange={this.handleOnChange}
          loading={this.props.loading}
          logo={this.props.data}
        />
      </Container>
    );
  }
}

export default withTranslation(namespaces)(EditLogo);



// WEBPACK FOOTER //
// ./src/containers/Logo/Edit.jsx